import db from "../../api/mongodb"


export const isLoggedIn = async (setFunc) => {
    var headerOptions = {
        method: "GET",
        credentials: 'include',
        headers: { 'Content-Type': "application/json", "Authorization": `${localStorage.getItem("token")}` }
    }

    const clientResponse = await fetch(
        `${process.env.REACT_APP_API_URL}:${process.env.REACT_APP_API_PORT}/api/safeAPs/isLoggedIn`,
        headerOptions
    )
       
    if (clientResponse.status===200){
        const data =await clientResponse.json()
        // console.log(data)
        setFunc(true)
    }else{
        setFunc(false)
    }
    // else {
    //     return true
    // }
   
}
